<div
  *ngIf="enableToggleSidNav"
  data-test-id="hdLogoComponentContainer"
  class="logoComponentContainer"
>
  <!-- <a
    *ngIf="enableToggleSidNav"
    class="icon-wrap icon-toggle"
    data-test-id="tglToggleSideNav"
    (click)="resizeSideNavToggleFn()"
    tabindex="0"
  >
    <cigna-icon [type]="'toggle-menu'"></cigna-icon>
  </a> -->
  <a [routerLink]="['/secure/home']" data-test-id="linkLogo">
    <img
      title="Cigna for Brokers Logo"
      alt="Cigna for Brokers Logo"
      class="logo"
      [src]="
        'spa/cigna-for-brokers/assets/images/cignahlthcr_logo_color.svg'
          | cdnPrefix
      "
      data-test-id="hdLogoImg"
    />
  </a>
  <span class="brLogoSep" *ngIf="isFromLogin">{{
    'broker.hBroker' | translate
  }}</span>
  <span class="brLogoSep brImpersonateLogoSep" *ngIf="isImpersonator"
    >Brokers: Impersonator Tool</span
  >
</div>
<a
  *ngIf="!enableToggleSidNav"
  [routerLink]="['/public/app/signin']"
  data-test-id="linkLogo"
>
  <img
    title="Cigna for Brokers Logo"
    alt="Cigna for Brokers Logo"
    class="logo"
    [src]="
      'spa/cigna-for-brokers/assets/images/cignahlthcr_logo_color.svg'
        | cdnPrefix
    "
    data-test-id="hdLogoImg"
  />
</a>
